const ngHeaderLogin = [() => {
    return {
        link: function ( $scope, $item ) {
            $scope.modules.add('login');
            if (!('ontouchstart' in document.documentElement)) {
                $item[0].addEventListener('mouseover', (e) => {
                    console.log('mouseover');
                    $scope.modules.show('login');
                    $scope.$apply();
                }, { passive: true });

                $item[0].addEventListener('mouseleave', () => {
                    console.log('mouseover');
                    $scope.modules.hide('login');
                    $scope.$apply();
                }, { passive: true });
            }
        }
    }
}];
export default ngHeaderLogin;
